import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import {
  PAYSDK_EVENTS,
  PAYSDK_EVENT_METADATA_KEYS,
  PAYSDK_TYPES,
  PAYSDK_CONTAINER_ID_PREFIXES,
} from 'constants/paysdk-constants';
import { usePaySdk } from './use-paysdk';
import PaySdkStatusView from './pay-sdk-status-view';
import styles from './pay-sdk-payment-recommendation.less';

const PaySdkPaymentRecommendation = ({
  onOpenPaymentList,
  onPaymentRecommended,
  selectedPaymentTypeID,
  deliveries,
  location,
  countryCode,
  enterprise,
  stateScope,
}) => {
  const handleEvent = useCallback(
    event => {
      if (!event) return;
      if (event.event === PAYSDK_EVENTS.CLICK_PAYMENT_RECOMMENDATION) {
        onOpenPaymentList();
      }
      if (event.event === PAYSDK_EVENTS.PAYMENT_RECOMMENDATION_RECEIVED) {
        const paymentTypeId = _get(
          event,
          PAYSDK_EVENT_METADATA_KEYS.PAYMENT_TYPE_ID,
          '',
        );
        if (paymentTypeId && onPaymentRecommended) {
          const paymentMethodType = _get(
            event,
            PAYSDK_EVENT_METADATA_KEYS.PAYMENT_METHOD_TYPE,
            '',
          );
          const shortTitle = _get(
            event,
            PAYSDK_EVENT_METADATA_KEYS.SHORT_TITLE,
            '',
          );
          onPaymentRecommended({
            paymentTypeId,
            paymentMethodType,
            shortTitle,
          });
        }
      }
    },
    [onOpenPaymentList, onPaymentRecommended],
  );

  const { containerRef, containerId, scriptLoaded, loadError } = usePaySdk({
    paySdkType: PAYSDK_TYPES.PAYMENT_RECOMMENDATION,
    location,
    deliveries,
    countryCode,
    enterprise,
    selectedPaymentTypeID,
    containerIdPrefix: PAYSDK_CONTAINER_ID_PREFIXES.PAYMENT_RECOMMENDATION,
    onEvent: handleEvent,
    stateScope,
  });

  return (
    <PaySdkStatusView
      loadError={loadError}
      scriptLoaded={scriptLoaded}
      errorFallbackKey="v2.homepage.manualOrder.failedToLoadPaymentRecommendation"
    >
      <div id={containerId} ref={containerRef} className={styles.container} />
    </PaySdkStatusView>
  );
};

PaySdkPaymentRecommendation.propTypes = {
  onOpenPaymentList: PropTypes.func.isRequired,
  onPaymentRecommended: PropTypes.func,
  selectedPaymentTypeID: PropTypes.string,
  deliveries: PropTypes.arrayOf(PropTypes.shape({})),
  location: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
  countryCode: PropTypes.string,
  enterprise: PropTypes.shape({
    groupID: PropTypes.string,
    profileType: PropTypes.string,
  }),
  stateScope: PropTypes.string,
};

PaySdkPaymentRecommendation.defaultProps = {
  onPaymentRecommended: null,
  selectedPaymentTypeID: '',
  deliveries: [],
  location: {},
  countryCode: '',
  enterprise: {},
  stateScope: undefined,
};

export default PaySdkPaymentRecommendation;
